import React from 'react'

const Cateringsubscription = () => {
    return (
        <div>

        </div>
    )
}

export default Cateringsubscription
